import { BotInfo, BrowserInfo, detect, NodeInfo, SearchBotDeviceInfo, ReactNativeInfo } from 'detect-browser';

import { isVersionSupported } from './isVersionSupported';

export const isBrowserSupported = (): boolean => {
  const browser: BrowserInfo | BotInfo | NodeInfo | SearchBotDeviceInfo | ReactNativeInfo | null = detect();
  const supportedBrowsers = [
    'edge',
    'edge-chromium',
    'samsung',
    'chrome',
    'firefox',
    'android',
    'ios',
    'crios',
    'safari',
    'opera',
  ];

  return browser
    ? supportedBrowsers.includes(browser.name) &&
        isVersionSupported(browser.name, browser.version ? browser.version : '')
    : false;
};
